// src/components/Footer.js
import React, { useState, useEffect } from 'react';
import logo from '../images/footer-logo.png';

const Footer = () => {
  const [contactInfo, setContactInfo] = useState({
    email: 'info@leaf-fb.com',
    phone: '+971 507 073 213',
    address: 'THREE LEAF FOOD & BEVERAGES TRADING L.L.C, DUBAI, UAE'
  });
  
  const [visibility, setVisibility] = useState({
    email: true,
    phone: true,
    address: true
  });

  const [lastUpdated, setLastUpdated] = useState(0);

  const API_BASE = process.env.REACT_APP_API_BASE || (typeof window !== 'undefined' ? window.location.origin : '');

  const fetchContactData = () => {
    // Fetch contact information
    fetch(API_BASE + '/backend/api.php/content?slug=contact')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        if (data && data.item && data.item.json) {
          // data.item.json is already parsed by the API
          const contactData = data.item.json;
          setContactInfo(contactData);
          setLastUpdated(Date.now());
        }
      })
      .catch(() => {});
  };

  const fetchVisibilitySettings = () => {
    // Fetch visibility settings
    fetch(API_BASE + '/backend/api.php/contact-visibility')
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        if (data && data.visibility) {
          setVisibility(data.visibility);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    // Initial fetch
    fetchContactData();
    fetchVisibilitySettings();

    // Set up interval to refresh data every 10 seconds
    const intervalId = setInterval(() => {
      fetchContactData();
      fetchVisibilitySettings();
    }, 10000); // Refresh every 10 seconds

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [API_BASE]);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Logo */}
          <div className="logo">
            <div className="logo-container">
              <img 
                src={logo} 
                alt="Three Leaf Logo" 
                className="logo-svg"
              /> 
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#products">Our Products</a></li>
              <li><a href="#industries">Industries</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
  <h4>Contact Us</h4>
  {visibility.email && (
    <p>
      {/* Email SVG icon from contact info */}
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
      <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
    </p>
  )}
  {visibility.phone && (
    <p>
      {/* Phone SVG icon from contact info */}
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path fill="currentColor" d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" />
      </svg>
      <a 
  href={`https://wa.me/${contactInfo.phone.replace(/\D/g, '')}`} 
  target="_blank" 
  rel="noopener noreferrer"
>
  {contactInfo.phone}
</a>
    </p>
  )}
  {visibility.address && (
    <p>
      {/* Address SVG icon from contact info */}
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
      {contactInfo.address}
    </p>
  )}
</div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Three Leaf Food & Beverages Trading L.L.C. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;